import { styled } from "@mui/material/styles";

export const ButtonProfile = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "10px 0",
});

export const TableWrapper = styled("div")(({ theme }) => ({
  "& .Nodata": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "300px",
  },
  "& .editname-form": {
    display: "flex",
    flexDirection: "column",
    padding: "15px",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    ":hover.MuiOutlinedInput-notchedOutline": {
      borderColor: "#f4f6f9",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ddd",
    },
  },

  "& .MuiInputBase-input": {
    "&.Mui-disabled": {
      WebkitTextFillColor: "#FFFFFF33",
      opacity: ".4",
    },
  },
  "& .delete-modal": {
    padding: "20px",
    background: "#FFFFFF33",
    display: " flex",
    flexDirection: "column",
    justifyContent: " center",
    alignItems: " center",
    "& .MuiTypography-h6": {
      marginBottom: " 24px",
      color: "#E22F0C",
    },
  },
  'svg[data-testid="ArrowDropDownIcon"]': {
    color: "#FFFFFF33",
  },
  "& .Selectbox": {
    border: `1px solid ${"#FFFFFF33"}`,
    borderRadius: "4px",
    padding: "5px 10px",
  },
}));

export const Userdetail = styled("div")(({ theme }) => ({
  "& .main-box": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& .inside-box": {
      display: "flex",
      width: "400px",
      justifyContent: "center",
      padding: "10px",
      borderRadius: "4px",
    },
    "& .MuiAvatar-root": {
      height: "200px",
      width: "200px",
      fontSize: "6.25em",
    },
  },
  "& .settings-box": {
    cursor: "pointer",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    display: "flex",
    width: "400px",
    padding: "10px",
    background: "#D0D5DD",
    borderRadius: "4px",
    marginTop: "20px",
  },
  "& .inner-settings-box": {
    display: "flex",
    flexDirection: "column",
    width: "400px",
    padding: "10px",
    borderRadius: "4px",
    marginTop: "10px",
  },

  "& .custom-icon-button": {
    marginBottom: "2rem",
  },
}));

export const ChangePassword = styled("div")(() => ({
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    ":hover.MuiOutlinedInput-notchedOutline": {
      borderColor: "#ddd",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ddd",
    },
  },
}));
